<template>
  <b-modal id="shop" title="Negozio" @ok="save" ok-title="Salva" @cancel="initValues()" cancel-title="Annulla" hide-header-close no-close-on-backdrop>
    <b-form-group class="col-md-12">
      <b-card-text>
        <b-form-row>
          <b-form-group label="Ragione Sociale" class="col-md-8">
            <b-form-input
              id="name"
              v-model="value.name"
              name="RagioneSociale"
              v-validate="{ required: true }"
              :state="stateValidation('RagioneSociale')"
              aria-describedby="input-name-feedback" />
            <b-form-invalid-feedback id="input-name-feedback">
              {{ veeErrors.first('RagioneSociale')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Codice" class="col-md-4">
            <b-form-input
              id="code"
              v-model="value.code"
              name="Codice"
              :disabled="isUpdate()"
              v-validate="{ min: 5, max: 5, regex: /^09/, required: true}"
              :state="stateValidation('Codice')"
              aria-describedby="input-code-feedback" />
            <b-form-invalid-feedback id="input-name-feedback">
              {{ veeErrors.first('Codice')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Indirizzo" class="col-md-12">
            <b-form-input
              id="street"
              v-model="value.street"
              name="Indirizzo"
              v-validate="{ required: true }"
              :state="stateValidation('Indirizzo')"
              aria-describedby="input-street-feedback"/>
            <b-form-invalid-feedback id="input-street-feedback">
              {{ veeErrors.first('Indirizzo')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Comune" class="col-md-12">
            <b-form-input
              id="city"
              v-model="value.city"
              name="Città"
              v-validate="{ required: true }"
              :state="stateValidation('Città')"
              aria-describedby="input-city-feedback"/>
            <b-form-invalid-feedback id="input-city-feedback">
              {{ veeErrors.first('Città')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Provincia" class="col-md-6">
            <b-form-input
              id="province"
              v-model="value.province"
              name="Provincia"
              v-validate="{ required: true }"
              :state="stateValidation('Provincia')"
              aria-describedby="input-province-feedback"/>
            <b-form-invalid-feedback id="input-province-feedback">
              {{ veeErrors.first('Provincia')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="CAP" class="col-md-6">
            <b-form-input
              id="postalCode"
              v-model="value.postalCode"
              v-validate="{ required: true, numeric: true, min: 5, max: 5 }"
              name="CAP"
              :state="stateValidation('CAP')"
              aria-describedby="input-postalcode-feedback" />
            <b-form-invalid-feedback id="input-postalcode-feedback">
              {{ veeErrors.first('CAP')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Partita Iva" class="col-md-12">
            <b-form-input
              id="vatCode"
              v-model="value.vatCode"
              name="PartitaIva"
              v-validate="{ required: true, numeric: true, min: 11, max: 11 }"
              :state="stateValidation('PartitaIva')"
              aria-describedby="input-vatcode-feedback" />
            <b-form-invalid-feedback id="input-vatcode-feedback">
              {{ veeErrors.first('PartitaIva')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Email" class="col-md-12">
            <b-form-input
              id="vatCode"
              v-model="value.email"
              name="Email"
              :state="stateValidation('Email')"
              aria-describedby="input-email-feedback"/>
            <b-form-invalid-feedback id="input-email-feedback">
              {{ veeErrors.first('Email')}}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Telefono" class="col-md-12">
            <b-form-input
              id="vatCode"
              v-model="value.phoneNumber"
              name="Telefono"
              :state="stateValidation('Telefono')"
              aria-describedby="input-phoneNumber-feedback"/>
            <b-form-invalid-feedback id="input-phoneNumber-feedback">
              {{ veeErrors.first('Telefono')}}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
      </b-card-text>
    </b-form-group>
  </b-modal>
</template>

<script>

export default {
  name: "Shop",
  props: ['shop', 'eventName'],
  inject: ['parentValidator'],
  data: () => ({
    value: {},
  }),
  watch: {
    shop() { this.initValues() }
  },
  created() {
    this.$validator = this.parentValidator
  },
  methods: {
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) return !this.veeErrors.has(ref)
      else return null
    },
    save(modalEvent) {
      modalEvent.preventDefault()

      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit(this.eventName, this.value)
          this.initValues()
        }
      })
    },
    isUpdate() { return this.eventName === "shop-modified" },
    initValues() {
      this.value = Object.assign({}, this.shop)
    }
  }
}
</script>

<style scoped>
</style>
